import axios from 'axios';
import { Token } from './token';
import Config from '@/config';

const baseUrl = `${Config.BaseAPI}/v3/user`;

export default {
  getUser: async function(userId) {
    const url = `${baseUrl}/${userId}`;

    const token = await Token.getToken();
    const headers = {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    };

    const result = await axios.get(url, { headers });
    return result.data.record;
  },

  searchUser: async function(keyword) {
    const url = `${baseUrl}?id=${keyword}&email=${keyword}&name=${keyword}`;

    const token = await Token.getToken();
    const headers = {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    };

    const result = await axios.get(url, { headers });
    return result.data.record;
  }
};
